export default function availableFishCards(cardData) {
  return cardData.length !== 0;
}
